import { jsx as _jsx } from "react/jsx-runtime";
import { CatButton } from '@blocks-react/components/Button';
export const DealerLocatorViewMoreResultsButton = ({ children, onClick, isDisabled, }) => (_jsx("div", { className: "w-100 text-center my-3", children: _jsx(CatButton, { className: "text-center", onClick: onClick, disabled: isDisabled, children: children }) }));
